import React from 'react';

import PropTypes from 'prop-types';
import Dropdown from 'react-bootstrap/Dropdown';
import Nav from 'react-bootstrap/Nav';
import { Link } from 'react-router-dom';

const HelpMenuItem = ({ displayName, url }) => {
    return (
        <Dropdown
            as={Nav.Item}
            title={displayName}
            id="nav-dropdown-help"
            className="nav-item"
            tabIndex={1000}
        >
            <Dropdown.Toggle
                as={Nav.Link}
                tabIndex={1000}
                role="link"
            >
                <span className="alerts-title">{displayName}</span>
            </Dropdown.Toggle>
            <Dropdown.Menu>
                <Dropdown.Item as={Link} to={url}>
                    Contact Us
                </Dropdown.Item>
                <Dropdown.Item as={Link} to="/ask-foremost" className="external-link" target="_blank">
                    Ask Foremost
                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
};

HelpMenuItem.propTypes = {
    displayName: PropTypes.string,
    url: PropTypes.string,
};

export default HelpMenuItem;
